import { Pipe, PipeTransform } from '@angular/core';
import * as moment_ from 'moment';

const moment = moment_;
/**
  * TimeSincePipe
  *
  * A pipe that uses moment to return time since
  **/
@Pipe({ name: 'timesince', pure: false })
export class TimeSincePipe implements PipeTransform {
  /**
  * Accepts time and returns value of time since moment.
  *
  * @param {any[]} value Any given array.
  * @return {any[]} Returns reversed value of given array.
  */
  transform(time: any): string {
    if (time !== undefined) {
      return moment(time).fromNow();
    }
    return 'N/A';
  }
}
